"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _helpers = require("@/helpers");
var _underLoading = require("../helpers/under-loading");
var _mutationTypes = require("../mutation-types");
var _dashboard = _interopRequireDefault(require("@/services/dashboard.service"));
var _mutations;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var state = {
  listConsumption: {},
  listLastResults: {},
  detailErroSelectedDashboard: null
};
var mutations = (_mutations = {}, _defineProperty(_mutations, _mutationTypes.SET_LIST_CONSUMPTION, function (mutationState, payload) {
  mutationState.listConsumption = payload;
}), _defineProperty(_mutations, _mutationTypes.SET_LIST_LAST_RESULTS, function (mutationState, payload) {
  mutationState.listLastResults = payload;
}), _defineProperty(_mutations, _mutationTypes.SET_DETAIL_OPEN_DASHBOARD, function (mutationState, payload) {
  mutationState.detailErroSelectedDashboard = payload;
}), _mutations);
var getters = {
  listConsumption: function listConsumption(state) {
    return state.listConsumption;
  },
  listLastResults: function listLastResults(state) {
    return state.listLastResults;
  },
  detailErroSelectedDashboard: function detailErroSelectedDashboard(state) {
    return state.detailErroSelectedDashboard;
  }
};
var actions = {
  fetchConsumption: function () {
    var _fetchConsumption = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref, _ref2) {
      var commit, days, params, _yield$DashboardServi, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            days = _ref2.days, params = _ref2.params;
            _context.prev = 2;
            _context.next = 5;
            return _dashboard.default.fetchConsumption(days, params);
          case 5:
            _yield$DashboardServi = _context.sent;
            data = _yield$DashboardServi.data;
            commit(_mutationTypes.SET_LIST_CONSUMPTION, data);
            return _context.abrupt("return", data);
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            _helpers.errorResponseHelper.display(_context.t0);
            return _context.abrupt("return", false);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 11]]);
    }));
    function fetchConsumption(_x, _x2) {
      return _fetchConsumption.apply(this, arguments);
    }
    return fetchConsumption;
  }(),
  fetchLastResults: function () {
    var _fetchLastResults = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref3, _ref4) {
      var commit, time, page, perPage, _yield$DashboardServi2, data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref3.commit;
            time = _ref4.time, page = _ref4.page, perPage = _ref4.perPage;
            _context2.prev = 2;
            _context2.next = 5;
            return _dashboard.default.fetchLastResults(time, page, perPage);
          case 5:
            _yield$DashboardServi2 = _context2.sent;
            data = _yield$DashboardServi2.data;
            commit(_mutationTypes.SET_LIST_LAST_RESULTS, data);
            return _context2.abrupt("return", data);
          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](2);
            _helpers.errorResponseHelper.display(_context2.t0);
            return _context2.abrupt("return", false);
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 11]]);
    }));
    function fetchLastResults(_x3, _x4) {
      return _fetchLastResults.apply(this, arguments);
    }
    return fetchLastResults;
  }(),
  fetchDetailDashboard: (0, _underLoading.underLoadingFunction)( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref5, payload) {
      var commit, _yield$DashboardServi3, data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref5.commit;
            _context3.prev = 1;
            _context3.next = 4;
            return _dashboard.default.fetchConsumptionDetail(payload);
          case 4:
            _yield$DashboardServi3 = _context3.sent;
            data = _yield$DashboardServi3.data;
            commit(_mutationTypes.SET_DETAIL_OPEN_DASHBOARD, data);
            return _context3.abrupt("return", data);
          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](1);
            _helpers.errorResponseHelper.display(_context3.t0);
            return _context3.abrupt("return", false);
          case 14:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 10]]);
    }));
    return function (_x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }()),
  setDetailDashboard: (0, _underLoading.underLoadingFunction)(function (_ref7, payload) {
    var commit = _ref7.commit;
    commit(_mutationTypes.SET_DETAIL_OPEN_DASHBOARD, payload);
  }),
  fetchDetailServiceActiveDashboard: (0, _underLoading.underLoadingFunction)( /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref8, payload) {
      var commit, _yield$DashboardServi4, data;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref8.commit;
            _context4.prev = 1;
            _context4.next = 4;
            return _dashboard.default.fetchDetailServiceActiveDashboard(payload);
          case 4:
            _yield$DashboardServi4 = _context4.sent;
            data = _yield$DashboardServi4.data;
            return _context4.abrupt("return", data);
          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](1);
            _helpers.errorResponseHelper.display(_context4.t0);
            return _context4.abrupt("return", false);
          case 13:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[1, 9]]);
    }));
    return function (_x7, _x8) {
      return _ref9.apply(this, arguments);
    };
  }()),
  fetchDetailServiceDashboard: (0, _underLoading.underLoadingFunction)( /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref10, payload) {
      var commit, _yield$DashboardServi5, data;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            commit = _ref10.commit;
            _context5.prev = 1;
            _context5.next = 4;
            return _dashboard.default.fetchDetailServiceDashboard(payload);
          case 4:
            _yield$DashboardServi5 = _context5.sent;
            data = _yield$DashboardServi5.data;
            return _context5.abrupt("return", data);
          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](1);
            _helpers.errorResponseHelper.display(_context5.t0);
            return _context5.abrupt("return", false);
          case 13:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[1, 9]]);
    }));
    return function (_x9, _x10) {
      return _ref11.apply(this, arguments);
    };
  }()),
  fetchLatestServiceCallDashboard: (0, _underLoading.underLoadingFunction)( /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(_ref12, payload) {
      var commit, _yield$DashboardServi6, data;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            commit = _ref12.commit;
            _context6.prev = 1;
            _context6.next = 4;
            return _dashboard.default.fetchLatestServiceCallDashboard(payload);
          case 4:
            _yield$DashboardServi6 = _context6.sent;
            data = _yield$DashboardServi6.data;
            return _context6.abrupt("return", data);
          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6["catch"](1);
            _helpers.errorResponseHelper.display(_context6.t0);
            return _context6.abrupt("return", false);
          case 13:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[1, 9]]);
    }));
    return function (_x11, _x12) {
      return _ref13.apply(this, arguments);
    };
  }()),
  fetchLatestServiceActiveCallDashboard: (0, _underLoading.underLoadingFunction)( /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(_ref14, payload) {
      var commit, _yield$DashboardServi7, data;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            commit = _ref14.commit;
            _context7.prev = 1;
            _context7.next = 4;
            return _dashboard.default.fetchLatestServiceActiveCallDashboard(payload);
          case 4:
            _yield$DashboardServi7 = _context7.sent;
            data = _yield$DashboardServi7.data;
            return _context7.abrupt("return", data);
          case 9:
            _context7.prev = 9;
            _context7.t0 = _context7["catch"](1);
            _helpers.errorResponseHelper.display(_context7.t0);
            return _context7.abrupt("return", false);
          case 13:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[1, 9]]);
    }));
    return function (_x13, _x14) {
      return _ref15.apply(this, arguments);
    };
  }()),
  fetchLatestCallServiceActiveChartDashboard: (0, _underLoading.underLoadingFunction)( /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(_ref16, payload) {
      var commit, _yield$DashboardServi8, data;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            commit = _ref16.commit;
            _context8.prev = 1;
            _context8.next = 4;
            return _dashboard.default.fetchLatestCallServiceActiveChartDashboard(payload);
          case 4:
            _yield$DashboardServi8 = _context8.sent;
            data = _yield$DashboardServi8.data;
            return _context8.abrupt("return", data);
          case 9:
            _context8.prev = 9;
            _context8.t0 = _context8["catch"](1);
            _helpers.errorResponseHelper.display(_context8.t0);
            return _context8.abrupt("return", false);
          case 13:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[1, 9]]);
    }));
    return function (_x15, _x16) {
      return _ref17.apply(this, arguments);
    };
  }()),
  fetchLatestServiceCallChartDashboard: (0, _underLoading.underLoadingFunction)( /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(_ref18, payload) {
      var commit, _yield$DashboardServi9, data;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            commit = _ref18.commit;
            _context9.prev = 1;
            _context9.next = 4;
            return _dashboard.default.fetchLatestServiceCallChartDashboard(payload);
          case 4:
            _yield$DashboardServi9 = _context9.sent;
            data = _yield$DashboardServi9.data;
            return _context9.abrupt("return", data);
          case 9:
            _context9.prev = 9;
            _context9.t0 = _context9["catch"](1);
            _helpers.errorResponseHelper.display(_context9.t0);
            return _context9.abrupt("return", false);
          case 13:
          case "end":
            return _context9.stop();
        }
      }, _callee9, null, [[1, 9]]);
    }));
    return function (_x17, _x18) {
      return _ref19.apply(this, arguments);
    };
  }()),
  fetchLatestServiceCallTotalDashboard: (0, _underLoading.underLoadingFunction)( /*#__PURE__*/function () {
    var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(_ref20, payload) {
      var commit, _yield$DashboardServi10, data;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            commit = _ref20.commit;
            _context10.prev = 1;
            _context10.next = 4;
            return _dashboard.default.fetchLatestServiceCallTotalDashboard(payload);
          case 4:
            _yield$DashboardServi10 = _context10.sent;
            data = _yield$DashboardServi10.data;
            return _context10.abrupt("return", data);
          case 9:
            _context10.prev = 9;
            _context10.t0 = _context10["catch"](1);
            _helpers.errorResponseHelper.display(_context10.t0);
            return _context10.abrupt("return", false);
          case 13:
          case "end":
            return _context10.stop();
        }
      }, _callee10, null, [[1, 9]]);
    }));
    return function (_x19, _x20) {
      return _ref21.apply(this, arguments);
    };
  }()),
  fetchLatestServiceCallTotalMonetizablesDashboard: (0, _underLoading.underLoadingFunction)( /*#__PURE__*/function () {
    var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(_ref22, payload) {
      var commit, _yield$DashboardServi11, data;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            commit = _ref22.commit;
            _context11.prev = 1;
            _context11.next = 4;
            return _dashboard.default.fetchLatestServiceCallTotalMonetizablesDashboard(payload);
          case 4:
            _yield$DashboardServi11 = _context11.sent;
            data = _yield$DashboardServi11.data;
            return _context11.abrupt("return", data);
          case 9:
            _context11.prev = 9;
            _context11.t0 = _context11["catch"](1);
            _helpers.errorResponseHelper.display(_context11.t0);
            return _context11.abrupt("return", false);
          case 13:
          case "end":
            return _context11.stop();
        }
      }, _callee11, null, [[1, 9]]);
    }));
    return function (_x21, _x22) {
      return _ref23.apply(this, arguments);
    };
  }()),
  fetchLatestServiceCallTotalErrorsDashboard: (0, _underLoading.underLoadingFunction)( /*#__PURE__*/function () {
    var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(_ref24, payload) {
      var commit, _yield$DashboardServi12, data;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            commit = _ref24.commit;
            _context12.prev = 1;
            _context12.next = 4;
            return _dashboard.default.fetchLatestServiceCallTotalErrorsDashboard(payload);
          case 4:
            _yield$DashboardServi12 = _context12.sent;
            data = _yield$DashboardServi12.data;
            return _context12.abrupt("return", data);
          case 9:
            _context12.prev = 9;
            _context12.t0 = _context12["catch"](1);
            _helpers.errorResponseHelper.display(_context12.t0);
            return _context12.abrupt("return", false);
          case 13:
          case "end":
            return _context12.stop();
        }
      }, _callee12, null, [[1, 9]]);
    }));
    return function (_x23, _x24) {
      return _ref25.apply(this, arguments);
    };
  }()),
  fetchTimesDocumentoscopia: (0, _underLoading.underLoadingFunction)( /*#__PURE__*/function () {
    var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(_ref26, payload) {
      var commit, _yield$DashboardServi13, data;
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            commit = _ref26.commit;
            _context13.prev = 1;
            _context13.next = 4;
            return _dashboard.default.fetchTimesDocumentoscopia(payload);
          case 4:
            _yield$DashboardServi13 = _context13.sent;
            data = _yield$DashboardServi13.data;
            return _context13.abrupt("return", data);
          case 9:
            _context13.prev = 9;
            _context13.t0 = _context13["catch"](1);
            _helpers.errorResponseHelper.display(_context13.t0);
            return _context13.abrupt("return", false);
          case 13:
          case "end":
            return _context13.stop();
        }
      }, _callee13, null, [[1, 9]]);
    }));
    return function (_x25, _x26) {
      return _ref27.apply(this, arguments);
    };
  }()),
  fetchTotalBilligServices: (0, _underLoading.underLoadingFunction)( /*#__PURE__*/function () {
    var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(_ref28, payload) {
      var commit, _yield$DashboardServi14, data;
      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            commit = _ref28.commit;
            _context14.prev = 1;
            _context14.next = 4;
            return _dashboard.default.fetchTotalBilligServices(payload);
          case 4:
            _yield$DashboardServi14 = _context14.sent;
            data = _yield$DashboardServi14.data;
            return _context14.abrupt("return", data);
          case 9:
            _context14.prev = 9;
            _context14.t0 = _context14["catch"](1);
            _helpers.errorResponseHelper.display(_context14.t0);
            return _context14.abrupt("return", false);
          case 13:
          case "end":
            return _context14.stop();
        }
      }, _callee14, null, [[1, 9]]);
    }));
    return function (_x27, _x28) {
      return _ref29.apply(this, arguments);
    };
  }()),
  fetchListErrorsDashboard: (0, _underLoading.underLoadingFunction)( /*#__PURE__*/function () {
    var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(_ref30, payload) {
      var commit, _yield$DashboardServi15, data;
      return _regeneratorRuntime().wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            commit = _ref30.commit;
            _context15.prev = 1;
            _context15.next = 4;
            return _dashboard.default.fetchListErrorsDashboard(payload);
          case 4:
            _yield$DashboardServi15 = _context15.sent;
            data = _yield$DashboardServi15.data;
            return _context15.abrupt("return", data);
          case 9:
            _context15.prev = 9;
            _context15.t0 = _context15["catch"](1);
            _helpers.errorResponseHelper.display(_context15.t0);
            return _context15.abrupt("return", false);
          case 13:
          case "end":
            return _context15.stop();
        }
      }, _callee15, null, [[1, 9]]);
    }));
    return function (_x29, _x30) {
      return _ref31.apply(this, arguments);
    };
  }()),
  featchLastServiceActiveCallsTotal: (0, _underLoading.underLoadingFunction)( /*#__PURE__*/function () {
    var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(_ref32, payload) {
      var commit, _yield$DashboardServi16, data;
      return _regeneratorRuntime().wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            commit = _ref32.commit;
            _context16.prev = 1;
            _context16.next = 4;
            return _dashboard.default.featchLastServiceActiveCallsTotal(payload);
          case 4:
            _yield$DashboardServi16 = _context16.sent;
            data = _yield$DashboardServi16.data;
            return _context16.abrupt("return", data);
          case 9:
            _context16.prev = 9;
            _context16.t0 = _context16["catch"](1);
            _helpers.errorResponseHelper.display(_context16.t0);
            return _context16.abrupt("return", false);
          case 13:
          case "end":
            return _context16.stop();
        }
      }, _callee16, null, [[1, 9]]);
    }));
    return function (_x31, _x32) {
      return _ref33.apply(this, arguments);
    };
  }()),
  featchLastServiceActiveCallsTotalMonetizables: (0, _underLoading.underLoadingFunction)( /*#__PURE__*/function () {
    var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(_ref34, payload) {
      var commit, _yield$DashboardServi17, data;
      return _regeneratorRuntime().wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            commit = _ref34.commit;
            _context17.prev = 1;
            _context17.next = 4;
            return _dashboard.default.featchLastServiceActiveCallsTotalMonetizables(payload);
          case 4:
            _yield$DashboardServi17 = _context17.sent;
            data = _yield$DashboardServi17.data;
            return _context17.abrupt("return", data);
          case 9:
            _context17.prev = 9;
            _context17.t0 = _context17["catch"](1);
            _helpers.errorResponseHelper.display(_context17.t0);
            return _context17.abrupt("return", false);
          case 13:
          case "end":
            return _context17.stop();
        }
      }, _callee17, null, [[1, 9]]);
    }));
    return function (_x33, _x34) {
      return _ref35.apply(this, arguments);
    };
  }()),
  featchLastServiceActiveCallsTotalErros: (0, _underLoading.underLoadingFunction)( /*#__PURE__*/function () {
    var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(_ref36, payload) {
      var commit, _yield$DashboardServi18, data;
      return _regeneratorRuntime().wrap(function _callee18$(_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            commit = _ref36.commit;
            _context18.prev = 1;
            _context18.next = 4;
            return _dashboard.default.featchLastServiceActiveCallsTotalErros(payload);
          case 4:
            _yield$DashboardServi18 = _context18.sent;
            data = _yield$DashboardServi18.data;
            return _context18.abrupt("return", data);
          case 9:
            _context18.prev = 9;
            _context18.t0 = _context18["catch"](1);
            _helpers.errorResponseHelper.display(_context18.t0);
            return _context18.abrupt("return", false);
          case 13:
          case "end":
            return _context18.stop();
        }
      }, _callee18, null, [[1, 9]]);
    }));
    return function (_x35, _x36) {
      return _ref37.apply(this, arguments);
    };
  }())
};
var _default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
exports.default = _default;